import { LicenceApplicationStatuses } from "../../../../../api/LicenceDetails";
import { MakeSubmissionOrObjection } from "../MakeSubmissionOrObjection";
import { GetAppTrackerLabel } from "../ApplicationTrackerUtils";
import { DynamicApplicationTracker } from "./DynamicApplicationTracker";
import { ILicenceApplicationTrackerProps } from "./ILicenceApplicationTrackerProps";
import { TrackerCard } from "../TrackerCard";
import { TrackerText } from "./TrackerText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPauseCircle } from "@fortawesome/free-regular-svg-icons";

const RequestForInformationSubStatus = () => {
  const foreGroundColor = "#014891";
  return (
    <table style={{ color: foreGroundColor, display: "inline" }}>
      <tr>
        <td style={{ paddingRight: "5px" }}>
          <FontAwesomeIcon
            className="fas fas fa-solid fa-2x"
            icon={faPauseCircle}
          />
        </td>
        <td style={{ verticalAlign: "top", paddingTop: "5px" }}>
          <h3>Request for Information Outstanding</h3>
        </td>
      </tr>
    </table>
  );
};

export const IndustrialEmissionsWasteAppTrackerDesktop = ({
  licence,
  licenceProfile,
}: ILicenceApplicationTrackerProps) => {
  const underAssessment =
    licence.lastatus ===
    LicenceApplicationStatuses.UnderAssessmentRequestForInformationOutstanding
      ? {
          value:
            LicenceApplicationStatuses.UnderAssessmentRequestForInformationOutstanding,
          label: LicenceApplicationStatuses.UnderAssessment,
        }
      : {
          value: LicenceApplicationStatuses.UnderAssessment,
          label: LicenceApplicationStatuses.UnderAssessment,
        };

  const availableStatuses = [
    {
      value: LicenceApplicationStatuses.ApplicationReceived,
      label: LicenceApplicationStatuses.ApplicationReceived,
    },
    underAssessment,
    {
      value: LicenceApplicationStatuses.ApplicationCompliance,
      label: LicenceApplicationStatuses.ApplicationCompliance,
    },
    {
      value: LicenceApplicationStatuses.ProposedDeterminationIssued,
      label: LicenceApplicationStatuses.ProposedDeterminationIssued,
    },
    {
      value: LicenceApplicationStatuses.ConsiderationofObjections,
      label: LicenceApplicationStatuses.ConsiderationofObjections,
    },
    {
      value: LicenceApplicationStatuses.AuthorisationIssued,
      label: LicenceApplicationStatuses.AuthorisationIssued,
    },
  ];

  const availableValues = availableStatuses.map((kv) => kv.value);
  const isTrackerVisible = availableValues.includes(licence.lastatus);
  const subStatus =
    licence.lastatus ===
    LicenceApplicationStatuses.UnderAssessmentRequestForInformationOutstanding ? (
      <RequestForInformationSubStatus />
    ) : (
      <div />
    );

  var bodyElements = (
    <div>
      <MakeSubmissionOrObjection
        licence={licence}
        licenceProfile={licenceProfile}
      />
      {isTrackerVisible && (
        <DynamicApplicationTracker
          availableStatuses={availableStatuses}
          currentStatus={licence.lastatus}
        />
      )}
      <TrackerText licence={licence} licenceProfile={licenceProfile} />
    </div>
  );

  return (
    <TrackerCard
      title={GetAppTrackerLabel({ licence, licenceProfile })}
      content={bodyElements}
      subStatusContent={subStatus}
    />
  );
};
